import styled from 'styled-components/macro';

export default styled.div`
  flex: 1 0 0;
`;
